import React from 'react';
import { Box, Typography } from '@mui/material';
import { LIVE_PREVIEW_PHONE_HEIGHT, LIVE_PREVIEW_PHONE_WIDTH } from '../eventLivePreviewModel';

const LivePreviewPhoneFrame = ({ title, subtitle, footer, children }) => (
  <Box
    sx={{
      width: { xs: '100%', lg: LIVE_PREVIEW_PHONE_WIDTH + 32 },
      flexShrink: 0,
      position: { lg: 'sticky' },
      top: { lg: 0 },
      alignSelf: { lg: 'flex-start' },
    }}
  >
    <Typography
      sx={{
        fontWeight: 700,
        fontSize: '0.8125rem',
        color: '#6b7280',
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        mb: 1.25,
      }}
    >
      {title}
    </Typography>
    {subtitle ? (
      <Typography sx={{ fontSize: '0.75rem', color: '#9ca3af', mb: 1.5, lineHeight: 1.45 }}>
        {subtitle}
      </Typography>
    ) : null}

    <Box
      sx={{
        mx: 'auto',
        width: { xs: `min(100%, ${LIVE_PREVIEW_PHONE_WIDTH}px)`, lg: LIVE_PREVIEW_PHONE_WIDTH },
        height: LIVE_PREVIEW_PHONE_HEIGHT,
        borderRadius: '36px',
        border: '10px solid #1A1A1A',
        boxShadow: '0 18px 48px rgba(0, 0, 0, 0.16)',
        overflow: 'hidden',
        bgcolor: '#FFFFFF',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 8,
          left: '50%',
          transform: 'translateX(-50%)',
          width: 96,
          height: 18,
          borderRadius: '12px',
          bgcolor: '#1A1A1A',
          zIndex: 3,
        }}
      />
      {children}
    </Box>

    {footer ? (
      <Typography sx={{ textAlign: 'center', fontSize: '0.6875rem', color: '#B0AAA6', mt: 1.25 }}>
        {footer}
      </Typography>
    ) : null}
  </Box>
);

export default LivePreviewPhoneFrame;
